import React, { FC } from "react";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";

const OverviewThisWeekTaskStatusMark: FC<{ status: string }> = ({ status }) => {
  const s = status?.toUpperCase() ?? "";

  if (s === "COMPLETED") {
    return (
      <span className="flex h-8 w-8 shrink-0 items-center justify-center">
        <CheckCircleFilled className="text-lg text-emerald-500" />
      </span>
    );
  }

  if (s === "FAILED") {
    return (
      <span className="flex h-8 w-8 shrink-0 items-center justify-center">
        <CloseCircleFilled className="text-lg text-red-500" />
      </span>
    );
  }

  return (
    <span className="flex h-8 w-8 shrink-0 items-center justify-center">
      <div className="flex h-[18px] w-[18px] rotate-45 items-center justify-center border border-neutral-400 bg-neutral-100">
        <span className="-rotate-45 text-[10px] font-bold leading-none text-neutral-600">
          M
        </span>
      </div>
    </span>
  );
};

export { OverviewThisWeekTaskStatusMark };
